module.exports = __webpack_public_path__ + "media/img/ms-icon-70x70-9b92a2e5d3ac6abc2295b6ba180416b8.png";